import styled from 'styled-components';

const ContentStyle = styled.div`
	--titleMarginTopBottom: var(--sp13x) 0 var(--sp6x) 0;
	--contentImageMarginBottom: var(--sp6x);
	--descriptionImageMargin: var(--sp8x) 0 var(--sp12x) 0;
	--descriptionImagePaddingTop: 50.5%;
	--publishedOnMarginTop: var(--sp13x);

	--downloadLinkMinWidth: var(--sp34x);
	--downloadLinkPadding: var(--sp2x) var(--sp4x);
	--downloadLinkMarginTop: var(--sp3x);
	--downloadLinkIconSizes: var(--sp2x);
	--downloadLinkIconMarginLeft: var(--sp1-5x);

	.content-image-block {
		width: 100%;
		border-radius: var(--sp2x);
		overflow: hidden;
		margin-bottom: var(--contentImageMarginBottom);
	}

	.content-image {
		width: 100%;

		img {
			border-radius: var(--sp2x);
			overflow: hidden;
		}
	}

	.content {
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			margin: var(--titleMarginTopBottom);
			font-size: var(--h5);
			font-family: var(--ping);
			font-weight: 700;
		}

		p {
			font-size: var(--p);
			font-family: var(--helvetica);
			font-weight: 400;

			&:last-child {
				margin-bottom: unset;
			}
		}

		.image {
			position: relative;
			width: 100%;
			padding-top: var(--descriptionImagePaddingTop);
			margin: var(--descriptionImageMargin);

			img {
				position: absolute;
				height: 100%;
				width: 100%;
				inset: 0px;
				object-fit: cover;
				object-position: center;
				border-radius: var(--sp2x);
			}
		}

		a {
			text-decoration: underline;
			color: var(--primaryColor2);
		}

		ul,
		ol {
			padding-left: var(--sp5x);
			li {
				font-size: var(--p);
				font-family: var(--helvetica);
				font-weight: 400;
			}
		}

		ul {
			list-style-type: disc;
		}
	}

	.additional {
		margin-top: var(--publishedOnMarginTop);
	}

	.published-on {
		margin-top: var(--publishedOnMarginTop);
	}

	.content-download-link {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: var(--downloadLinkMinWidth);
		width: fit-content;
		padding: var(--downloadLinkPadding);
		border: 1px solid var(--primaryColor1);
		border-radius: var(--sp1-5x);
		transition: var(--trTime);
		margin-top: var(--downloadLinkMarginTop);

		@media (hover: hover) {
			&:hover {
				background-color: var(--primaryColor1);
				color: var(--primaryColor3);
			}
		}

		.download-btn-icon {
			font-size: var(--downloadLinkIconSizes);
			margin-left: var(--downloadLinkIconMarginLeft);
			transform: rotate(90deg);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--titleMarginTopBottom: var(--sp7x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp4x);
		--descriptionImageMargin: var(--sp6x) 0 var(--sp10x) 0;
		--publishedOnMarginTop: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--titleMarginTopBottom: var(--sp8x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp4x);
		--descriptionImageMargin: var(--sp6x) 0 var(--sp10x) 0;
		--publishedOnMarginTop: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--titleMarginTopBottom: var(--sp8x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp4x);
		--descriptionImageMargin: var(--sp6x) 0 var(--sp10x) 0;
		--publishedOnMarginTop: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--titleMarginTopBottom: var(--sp7x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp3x);
		--descriptionImageMargin: var(--sp4x) 0 var(--sp8x) 0;
		--publishedOnMarginTop: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--titleMarginTopBottom: var(--sp5x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp2x);
		--descriptionImageMargin: var(--sp4x) 0 var(--sp7x) 0;
		--publishedOnMarginTop: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--titleMarginTopBottom: var(--sp5x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp2x);
		--descriptionImageMargin: var(--sp4x) 0 var(--sp7x) 0;
		--publishedOnMarginTop: var(--sp5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--titleMarginTopBottom: var(--sp5x) 0 var(--sp3x) 0;
		--contentImageMarginBottom: var(--sp2x);
		--descriptionImageMargin: var(--sp4x) 0 var(--sp6x) 0;
		--publishedOnMarginTop: var(--sp5x);
	}
`;

export default ContentStyle;
